import { createAction, props } from '@ngrx/store';
import { InternalListOrganization } from 'src/app/accounts/lists.component.types';
import { OrganizationRoleMap } from 'src/app/organization/shared/organization.types';
import { IAccountsState } from './accounts.feature';
import { Account } from 'src/app/shared/account/account.types';

const getType = (actionType: string) => `[Accounts] ${actionType}`;

// Publishers
export const fetchPublishers = createAction(
  getType('Fetch publishers'),
);

export const setPublishers = createAction(
  getType('Set publishers'),
  props<{ publishers: IAccountsState['publishers'] }>(),
);

export const addToPublishersStats = createAction(
  getType('Add to publishers stats'),
  props<{ stats: Account.PublisherWithStatsResponse[] }>(),
);

export const addToPublishersStatsLoadingIds = createAction(
  getType('Add to publishers stats loading ids'),
  props<{ ids: IAccountsState['publishersStatsLoadingIds'] }>(),
);

export const setNextPublishersPage = createAction(
  getType('Set next publishers page'),
);

export const setPublishersFilter = createAction(
  getType('Set publishers filter'),
  props<{ searchTerm: IAccountsState['publisherFilter'] }>(),
);

// Advertisers
export const fetchAdvertisers = createAction(
  getType('Fetch advertisers'),
);

export const setAdvertisers = createAction(
  getType('Set advertisers'),
  props<{ advertisers: IAccountsState['advertisers'] }>(),
);

export const addToAdvertisersStats = createAction(
  getType('Add to advertisers stats'),
  props<{ stats: Account.AdvertiserWithStatsResponse[] }>(),
);

export const addToAdvertisersStatsLoadingIds = createAction(
  getType('Add to advertisers stats loading ids'),
  props<{ ids: IAccountsState['advertisersStatsLoadingIds'] }>(),
);

export const setNextAdvertisersPage = createAction(
  getType('Set next advertisers page'),
);

export const setAdvertisersFilter = createAction(
  getType('Set advertisers filter'),
  props<{ searchTerm: IAccountsState['advertiserFilter'] }>(),
);

// Organizations
export const fetchOrganizations = createAction(
  getType('Fetch organizations'),
  props<{ rolePerOrganization?: OrganizationRoleMap }>(),
);

export const setOrganizations = createAction(
  getType('Set organizations'),
  props<{ organizations: InternalListOrganization[] }>(),
);
